import { Button, Modal } from '@ntconsult/aluma-react';
import { useTranslation } from 'react-i18next';

export type Ignorado = { nome: string; codigo: string };

/** "Ver motivos" do toast do lote: quem foi ignorado e por quê (spec 14 R7). */
export function MotivosIgnoradosModal({
  ignorados,
  onClose,
}: {
  ignorados: Ignorado[] | null;
  onClose: () => void;
}) {
  const { t } = useTranslation(['participantes', 'common']);
  return (
    <Modal open={ignorados !== null} onClose={onClose} ariaLabel={t('lote.motivosTitulo')}>
      <Modal.Header
        title={t('lote.motivosTitulo')}
        onClose={onClose}
        dismissLabel={t('common:close')}
      />
      <Modal.Body>
        <ul className="flex flex-col gap-2 text-sm">
          {ignorados?.map((i, n) => (
            // biome-ignore lint/suspicious/noArrayIndexKey: a mesma pessoa pode repetir com outro código
            <li key={`${i.nome}-${n}`} className="flex flex-wrap gap-x-2">
              <span className="font-medium">{i.nome}</span>
              <span className="text-foreground-muted">
                {t(`participantes:codigos.${i.codigo}` as never, { defaultValue: i.codigo })}
              </span>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('common:close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
